export default function GapHorizontalIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14 1.5L11 1.5L11 12.5L14 12.5' stroke='#848484' />
      <path d='M0 12.5L3 12.5L3 1.5L1.44248e-06 1.5' stroke='#848484' />
      <path d='M7 3.5L7 10.5' stroke='#848484' />
    </svg>
  );
}
